import { Link } from "react-router-dom";
import { Instagram, Mail, ArrowUpRight, Phone } from "lucide-react";
import { useContent } from "@/context/ContentContext";

export const Footer = ({ light = false }) => {
  const { logo, contact } = useContent();
  const t = light
    ? { bg: "bg-[#EFE9DD]", border: "border-black/10", head: "text-[#1a1a1a]", sub: "text-black/60", link: "text-black/70", btn: "border-black/30 hover:bg-[#1a1a1a] hover:text-[#F4EFE6]" }
    : { bg: "bg-ink", border: "border-white/10", head: "text-cream", sub: "text-muted2", link: "text-cream/80", btn: "border-white/30 hover:bg-cream hover:text-ink" };

  return (
    <footer data-testid="site-footer" className={`${t.bg} border-t ${t.border} pt-24 pb-10`}>
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-6">
            <h2 className={`font-serif text-5xl md:text-7xl font-light tracking-tight leading-none ${t.head}`}>
              Let's create<br />something <span className="italic text-gold">timeless.</span>
            </h2>
            <Link
              to="/contact"
              data-testid="footer-inquire-link"
              className={`inline-flex items-center gap-3 mt-10 text-xs uppercase tracking-[0.25em] border ${t.btn} px-8 py-4 transition-colors duration-500 ${t.head}`}
            >
              Start an Inquiry <ArrowUpRight size={16} />
            </Link>
          </div>

          <div className="md:col-span-3 md:col-start-8">
            <p className={`text-[0.65rem] uppercase tracking-[0.35em] ${t.sub} mb-6`}>Studio</p>
            <img src={logo} alt="Ghajoyan Photo" className="h-12 w-auto" />
            <p className={`${t.sub} mt-3`}>{contact.location}</p>
          </div>

          <div className="md:col-span-2">
            <p className={`text-[0.65rem] uppercase tracking-[0.35em] ${t.sub} mb-6`}>Connect</p>
            <a href={`tel:${contact.phoneLink}`} data-testid="footer-phone" className={`flex items-center gap-2 ${t.link} hover:text-gold transition-colors duration-500 mb-3`}>
              <Phone size={16} /> {contact.phone}
            </a>
            <a href={`https://instagram.com/${contact.instagram}`} target="_blank" rel="noreferrer" data-testid="footer-instagram" className={`flex items-center gap-2 ${t.link} hover:text-gold transition-colors duration-500 mb-3`}>
              <Instagram size={16} /> @{contact.instagram}
            </a>
            <a href={`mailto:${contact.email}`} data-testid="footer-email" className={`flex items-center gap-2 ${t.link} hover:text-gold transition-colors duration-500`}>
              <Mail size={16} /> {contact.email}
            </a>
          </div>
        </div>

        <div className={`mt-24 pt-8 border-t ${t.border} flex flex-col md:flex-row justify-between gap-4 text-xs uppercase tracking-[0.2em] ${t.sub}`}>
          <span>© {new Date().getFullYear()} Ghajoyan Photo. All rights reserved.</span>
          <span>Luxury Photography & Cinematic Storytelling</span>
        </div>
      </div>
    </footer>
  );
};
